module.exports = __webpack_public_path__ + "img/Tunisia.d46c66d7.png";